module.exports = __webpack_public_path__ + "img/img_brand3.26a330fd.jpg";